import { Button } from '../ui/button'
import { TOP_BAR_TAB_CLASS, TOP_BAR_TABS_CLASS } from './topBarTabs'

interface ProductNavTabsProps<T extends string> {
  tabs: { value: T; label: string }[]
  active: T
  onSelect: (tab: T) => void
}

/** The top bar's products: line tabs to look at, but a nav with aria-current, since there are no tab panels. */
export function ProductNavTabs<T extends string>({ tabs, active, onSelect }: ProductNavTabsProps<T>) {
  return (
    <nav aria-label="Cai products" className="h-full">
      <div className={TOP_BAR_TABS_CLASS}>
        {tabs.map((tab) => {
          const current = tab.value === active
          return (
            <Button
              key={tab.value}
              variant="iconOnly"
              aria-current={current ? 'page' : undefined}
              data-state={current ? 'active' : 'inactive'}
              onClick={() => onSelect(tab.value)}
              className={TOP_BAR_TAB_CLASS}
            >
              {tab.label}
            </Button>
          )
        })}
      </div>
    </nav>
  )
}
